/* eslint-disable react/jsx-no-undef */
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { SearchPrizeById } from "../../services/Prize";
import SecondaryButton from "../../components/button/SecondaryButton";
import CustomPopup from "../../components/popup/CustomPopup";

export default function LuckyDrawResultDetail() {


    const [prizeDetail, setPrizeDetail] = useState(false)
    const navigate = useNavigate();
    const { state } = useLocation();

    const [openAddressPopup, setOpenAddressPopup] = React.useState(false);

    React.useEffect(() => {
        getSearchPrizeById();
    }, []);

    async function getSearchPrizeById() {
        return await SearchPrizeById(state.prizeId)
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setPrizeDetail(response.data.body)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function submitData() {
        if (prizeDetail.fullDeAddress) {
            navigate('/prize-address', { state: prizeDetail })
            // await postUpdatePrize()
        } else {
            setOpenAddressPopup(true)
        }

    }


    return (
        <>
            <TopLogo />
            <div
                style={{
                    background: "#005AAA",
                    minHeight: "calc(100vh - 60px)",
                    paddingTop: "20px"
                }}
            >

                <div className="text-white text-center text-[34px] mt-[30px]">
                    รายละเอียด
                </div>

                <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 250px)" }}>
                    <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">
                        <div className="flex justify-between">
                            <p className="text-darkGray text-[20px] leading-[19.2px] px-[16px]">{state.campaignName}</p>
                            <p className="text-darkGray text-[20px] leading-[19.2px] w-[110px]">จำนวน {state.campaignUsed} สิทธิ์</p>
                        </div>

                        <p className="text-blue font-bold text-[24px] px-[16px]">คุณคือผู้โชคดี</p>

                        <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[15px]" />

                        <p className="text-darkGray text-[12px] leading-[19.2px] px-[16px]">รายละเอียดรางวัล</p>

                        <div className="flex justify-between mb-[20px]">
                            <p className="text-blue text-[16px] leading-[19.2px] px-[16px] ml-[20px]">{state.name}</p>
                            <p className="text-blue text-[16px] leading-[19.2px] px-[16px]">1</p>
                        </div>

                        <SecondaryButton
                            className="mt-[20px]"
                            fullWidth
                            variant="outlined"
                            onClick={() => submitData()}
                        >
                            <p>รับรางวัล</p>
                        </SecondaryButton>


                        <br></br>
                    </div>

                </div>
            </div>
            <div className="bg-white w-full" style={{
                position: 'fixed',
                bottom: 0,
                padding: '20px'
            }}>
                <div className="place-content-center">
                    <SecondaryButton
                        fullWidth
                        variant="outlined"
                        onClick={() => navigate(-1)}
                    >
                        <p>ย้อนกลับ</p>
                    </SecondaryButton>
                </div>

            </div>

            <CustomPopup
                title={"คุณยังไม่ได้เพิ่มที่อยู่"}
                desc={"กรุณากรอกข้อมูลที่อยู่ของคุณ\nเพื่อรับของรางวัลพิเศษ"}
                actionText={'กรอกข้อมูลที่อยู่'}
                actionFunction={() => {
                    setOpenAddressPopup(false);
                    navigate('/prize-address', { state: prizeDetail })
                }}
                open={openAddressPopup}
            />
        </>
    );
}
